import React, { useState, useEffect } from "react";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import { calculateFinePerMinute } from "../../utils/helper";
import moment from "moment";
import { set } from "react-hook-form";

const FineModal = ({ item, baseUrl, openToast, onClose, fetchAttendance }) => {
  const [lateEntryHours, setLateEntryHours] = useState("00:00");
  const [lateEntrySalaryTime, setLateEntrySalaryTime] = useState(1);
  const [lateEntryAmount, setLateEntryAmount] = useState(0);

  const [excessBreakHours, setExcessBreakHours] = useState("00:00");
  const [excessBreakTime, setExcessBreakTime] = useState(1);
  const [excessBreakAmount, setExcessBreakAmount] = useState(0);

  const [earlyOutHours, setEarlyOutHours] = useState("00:00");
  const [earlyOutTime, setEarlyOutTime] = useState(1);
  const [earlyOutAmount, setEarlyOutAmount] = useState(0);

  const [fineTotalAmount, setFineTotalAmount] = useState(0);
  const [selectedStaffSalary, setSelectedStaffSalary] = useState(0);
  const [perMinSalary, setPerMinSalary] = useState(0);

  const formatMinutesToHHMM = (minutes) => {
    const duration = moment.duration(minutes, "minutes");
    const hours = Math.floor(duration.asHours());
    const mins = Math.floor(duration.asMinutes() % 60);
    return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
  };

  console.log("render fine", item);

  const calculateDynamicFine = (punchRecord) => {
    if (!punchRecord.shift) {
      return { lateInMinutes: 0, earlyOutMinutes: 0 };
    }

    // Parse shift start and end times
    const shiftStart = moment(punchRecord.shift.shiftStartTime, "hh:mm A");
    const shiftEnd = moment(punchRecord.shift.shiftEndTime, "hh:mm A");

    // Parse punch-in and punch-out times
    let punchIn = punchRecord.punchIn?.punchInTime
      ? moment(punchRecord.punchIn.punchInTime)
      : null;
    let punchOut = punchRecord.punchOut?.punchOutTime
      ? moment(punchRecord.punchOut.punchOutTime)
      : null;

    // If punch-in exists, adjust shift start to match the same date as punch-in
    if (punchIn) {
      shiftStart.set({
        year: punchIn.year(),
        month: punchIn.month(),
        date: punchIn.date(),
      });
    }

    // If punch-out exists, adjust shift end to match the same date as punch-out
    if (punchOut) {
      shiftEnd.set({
        year: punchOut.year(),
        month: punchOut.month(),
        date: punchOut.date(),
      });
    }

    // Adjust shiftEnd for the case where it is after midnight (i.e., punch-out is the next day)
    if (shiftEnd.isBefore(shiftStart)) {
      shiftEnd.add(1, "day");
    }

    // Calculate late-in and early-out minutes
    const lateInMinutes = punchIn
      ? Math.max(0, punchIn.diff(shiftStart, "minutes")) // late if punch-in is after shiftStart
      : 0;
    const earlyOutMinutes = punchOut
      ? Math.max(0, shiftEnd.diff(punchOut, "minutes")) // early if punch-out is before shiftEnd
      : 0;

    console.log(lateInMinutes, earlyOutMinutes);

    return { lateInMinutes, earlyOutMinutes };
  };

  useEffect(() => {
    const totalSalary = lateEntryAmount + excessBreakAmount + earlyOutAmount;
    setFineTotalAmount(totalSalary);
  }, [lateEntryAmount, excessBreakAmount, earlyOutAmount]);

  useEffect(() => {
    if (item.punchRecord.length > 0) {
      const salary =
        item?.staffDetails?.SalaryDetails[0]?.ctc_amount ?? 0;
      const minSalary = calculateFinePerMinute(salary, 30, 8);
      setSelectedStaffSalary(salary);
      setPerMinSalary(minSalary);
      if (item.punchRecord[0].fine) {
        setLateEntryHours(
          item.punchRecord[0].fine.lateEntryFineHoursTime ?? "00:00"
        );
        setLateEntrySalaryTime(item.punchRecord[0].fine.lateEntryFineAmount ?? 1);
        setLateEntryAmount(item.punchRecord[0].fine.lateEntryAmount);
        setExcessBreakHours(
          item.punchRecord[0].fine.excessBreakFineHoursTime ?? "00:00"
        );
        setExcessBreakTime(item.punchRecord[0].fine.excessBreakFineAmount ?? 1);
        setExcessBreakAmount(item.punchRecord[0].fine.excessBreakAmount);
        setEarlyOutHours(
          item.punchRecord[0].fine.earlyOutFineHoursTime ?? "00:00"
        );
        setEarlyOutTime(item.punchRecord[0].fine.earlyOutFineAmount ?? 1);
        setEarlyOutAmount(item.punchRecord[0].fine.earlyOutAmount);
        setFineTotalAmount(item.punchRecord[0].fine.totalAmount ?? 0);
      } else {
        const { lateInMinutes, earlyOutMinutes } = calculateDynamicFine(
          item.punchRecord[0]
        );
        console.log(
          lateInMinutes,
          earlyOutMinutes,
          minSalary,
          lateInMinutes * minSalary,
          earlyOutMinutes * minSalary
        );
        setLateEntryHours(formatMinutesToHHMM(lateInMinutes));
        setLateEntryAmount(lateInMinutes * minSalary);
        setEarlyOutHours(formatMinutesToHHMM(earlyOutMinutes));
        setEarlyOutAmount(earlyOutMinutes * minSalary);

        const totalSalary = (lateInMinutes + earlyOutMinutes) * minSalary;
        setFineTotalAmount(totalSalary);
      }
    }
  }, [item]);

  const handleChangeTime = (field, value, amount) => {
    const formattedTime = value?.format("HH:mm");
    const [hours, minutes] = formattedTime.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;

    switch (field) {
      case "lateEntry":
        setLateEntryHours(formattedTime);
        setLateEntryAmount(amount * totalMinutes);
        break;
      case "excessBreak":
        setExcessBreakHours(formattedTime);
        setExcessBreakAmount(amount * totalMinutes);
        break;
      case "earlyOut":
        setEarlyOutHours(formattedTime);
        setEarlyOutAmount(amount * totalMinutes);
        break;
    }
  };

  const applyFine = async () => {
    if (!item.punchRecord[0].shift) {
      openToast("Please Select Shift for " + item.punchRecord[0].status + " status", "warning");
      return;
    }
    const data = {
      lateEntryFineHoursTime: lateEntryHours,
      lateEntryFineAmount: parseFloat(lateEntrySalaryTime),
      lateEntryAmount: lateEntryAmount,
      excessBreakFineHoursTime: excessBreakHours,
      excessBreakFineAmount: parseFloat(excessBreakTime),
      excessBreakAmount: excessBreakAmount,
      earlyOutFineHoursTime: earlyOutHours,
      earlyOutFineAmount: parseFloat(earlyOutTime),
      earlyOutAmount: earlyOutAmount,
      totalAmount: fineTotalAmount,
      staffId: item.staffId,
      punchRecordId: item.punchRecord[0].id,
      shiftIds: item.punchRecord[0].shift?.id,
    };

    try {
      const result = await fetch(`${baseUrl}fine/create`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${localStorage.getItem(
            "flowChangerAuthToken"
          )}`,
        },
        body: JSON.stringify(data),
      });

      if (result.ok) {
        openToast("Fine Applied Successfully", "success");
        onClose();
        fetchAttendance();
      } else {
        openToast("Something went wrong", "error");
      }
    } catch (err) {
      console.error(err);
      openToast("Something went wrong", "error");
    }
  };

  return (
    <div className="z-50 fixed inset-0 flex justify-center items-center bg-[#ffffffbf] bg-opacity-50 p-[10px]">
      <div className="bg-white shadow-cs p-6 rounded-lg w-full max-w-lg h-full sm:h-auto overflow-y-scroll scroll-bar-design">
        <h2 className="mb-4 font-semibold text-[18px] text-[black] text-xl">
          Fine
        </h2>
        <p className="mb-4 text-[14px]">
          {item.staffDetails.User.name} |{" "}
          {new Date(item.punchRecord[0].punchDate).toLocaleDateString()}
        </p>

        <FineSection
          title="Late Entry"
          hours={lateEntryHours}
          onChangeTime={(value) =>
            handleChangeTime("lateEntry", value, perMinSalary)
          }
          salaryTime={lateEntrySalaryTime}
          onChangeSalaryTime={setLateEntrySalaryTime}
          amount={lateEntryAmount}
          perMinSalary={perMinSalary}
        />

        <FineSection
          title="Excess Breaks"
          hours={excessBreakHours}
          onChangeTime={(value) =>
            handleChangeTime("excessBreak", value, perMinSalary)
          }
          salaryTime={excessBreakTime}
          onChangeSalaryTime={setExcessBreakTime}
          amount={excessBreakAmount}
          perMinSalary={perMinSalary}
        />

        <FineSection
          title="Early Out"
          hours={earlyOutHours}
          onChangeTime={(value) =>
            handleChangeTime("earlyOut", value, perMinSalary)
          }
          salaryTime={earlyOutTime}
          onChangeSalaryTime={setEarlyOutTime}
          amount={earlyOutAmount}
          perMinSalary={perMinSalary}
        />

        <div className="mt-4 mb-4">
          <span className="text-[12px]">Total Amount</span>
          <p className="text-[14px]">{fineTotalAmount.toFixed(2)}</p>
        </div>

        <div className="flex items-center gap-[4px] mb-4">
          <input type="checkbox" id="sendSms" />
          <label htmlFor="sendSms" className="text-[14px]">
            Send SMS to Staff
          </label>
        </div>

        {selectedStaffSalary === 0 && (
          <p className="mb-4 w-full text-[#ff0000] text-center text-sm">
            Please add {item.staffDetails.User.name}'s salary before
            applying a fine.
          </p>
        )}

        <div className="flex flex-col gap-[10px]">
          <button
            disabled={perMinSalary === 0}
            onClick={applyFine}
            className="border-[#27004a] bg-[#27004a] hover:bg-[#ffff] px-4 py-2 border rounded-md text-white hover:text-[#27004a] transition-all disabled:cursor-not-allowed"
          >
            Apply Fine
          </button>
          <button
            onClick={onClose}
            className="bg-[#27004a] px-4 py-2 rounded-md text-white"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const FineSection = ({
  title,
  hours,
  onChangeTime,
  salaryTime,
  onChangeSalaryTime,
  amount,
  perMinSalary,
}) => (
  <div className="mb-4">
    <p className="mb-2 font-medium text-[14px]">{title}</p>
    <div className="flex sm:flex-row flex-col items-start sm:items-center gap-[4px] sm:gap-[20px] mb-2">
      <div className="w-full sm:w-[33%]">
        <p className="text-[12px]">Hours</p>
        <TimePicker
          showSecond={false}
          className="w-full sm:w-auto"
          onChange={onChangeTime}
          format="HH:mm"
          inputReadOnly
          placeholder={hours}
        />
        <p className="text-[12px]">
          Amount: {(amount * salaryTime).toFixed(2)}
        </p>
      </div>
      <div className="flex sm:flex-row flex-col gap-[10px] sm:gap-[28px] w-full sm:w-[66%]">
        <div className="w-[100%]">
          <select
            onChange={(e) => onChangeSalaryTime(parseFloat(e.target.value))}
            className="border-[#c9c9c9] pt-[6px] pr-[20px] pb-[6px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
          >
            <option value={1}>1x Salary</option>
            <option value={1.5}>1.5x Salary</option>
          </select>
        </div>
        <div className="">
          <p className="p-[6px] rounded-md w-full sm:w-[124px] text-[14px] select-pe">
            {perMinSalary.toFixed(2)} Per Min
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default FineModal;